 import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";
import { useRouter } from "@core/utils/utils";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useCptuList() {
  // Use toast
  const toast = useToast();

  const refCptuListTable = ref(null);

  // filter options
  const cptuStatusOptions = [
    { label: "En cours", key: 'pending' },
    { label: "En traitement", key: 'processing' },
    { label: "Terminé", key: 'completed' },
    { label: "Échoué", key: 'failed' },
    { label: "Erreur", key: 'error' },
  ];

  // Table Handlers
  const tableColumns = [
    { label: "Nº", key: "index", sortable: true },
    { label: "Fichier", key: "original_file_name", sortable: true },
    { label: "Project", key: "project" },
    { label: "Détails", key: "details" },
    { label: "Statut", key: "is_active", sortable: true },
    { key: "actions" },
  ];
  const perPage = ref(10);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("created_at");
  const isSortDirDesc = ref(true);
  const cptuStatusFilter = ref(null);

  const cptuList = computed(() => {
    return store.getters["cptu/all"];
  });

  const totalCptu = computed(() => {
    const meta = store.getters["cptu/meta"];
    return meta?.total ?? 0;
  });

  const dataMeta = computed(() => {
    const localItemsCount = refCptuListTable.value
      ? refCptuListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalCptu.value,
    };
  });

  const refetchData = () => {
    refCptuListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, cptuStatusFilter], () => {
    refetchData();
  });

  const fetchCptuList = (ctx, callback) => {
    store
      .dispatch("cptu/fetchCptuTreatmentsList", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        is_active: cptuStatusFilter.value,
      })
      .then(() => {
        callback(cptuList.value);
      });
  };

  const deleteCptu = async (cptuID) => {
    const { data, status } = await store.dispatch("cptu/destroyCptu", {
      id: cptuID,
    });
    if (status !== 200) {
      toast({
        component: ToastificationContent,
        props: {
          title: data.error,
          icon: "AlertTriangleIcon",
          variant: "error",
        },
      });
    } else {
      toast({
        component: ToastificationContent,
        props: {
          title: "La mesure a été supprimée avec succès.",
          icon: "AlertTriangleIcon",
          variant: "success",
        },
      });
      refetchData();
    }
  };

  return {
    fetchCptuList,
    tableColumns,
    perPage,
    currentPage,
    totalCptu,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refCptuListTable,
    refetchData,
    deleteCptu,

    cptuStatusFilter,
    cptuStatusOptions,
  };
}
